import { Create } from "@mui/icons-material";
import { Link } from "@mui/material";

export const getUnderwritingQuestionModalContent =
  (text = "Edit", withIcon = true) =>
  (
    cardName: string,
    onClick: () => void,
    hidden?: boolean
  ): JSX.Element | undefined => {
    const RenderedContent = () => {
      if (!hidden) {
        return (
          <Link
            onClick={onClick}
            color="secondary"
            variant="body2"
            underline="always"
            sx={{ cursor: "pointer" }}>
            {withIcon && (
              <Create fontSize="inherit" style={{ marginRight: "12px" }} />
            )}
            {text}
          </Link>
        );
      }

      return null;
    };
    RenderedContent.displayName = `GetContentButton-${cardName}`;

    return RenderedContent()!;
  };
